<template>
  <div 
    class="card" 
    :class="[
      shadow ? 'card-shadow' : '',
      hover ? 'card-hover card-lift' : '',
      animateIn ? `animate-${animateIn}` : '',
      borderColor ? `border-${borderColor}` : '',
      'card-with-transition'
    ]"
    :style="customStyle"
  >
    <div class="card-header" v-if="title || $slots.header">
      <slot name="header">
        <h4 class="card-title mb-0">{{ title }}</h4>
      </slot>
    </div>
    
    <div class="card-body">
      <slot></slot>
    </div>
    
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: ''
    },
    shadow: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: false
    },
    animateIn: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    borderColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    customStyle() {
      const style = {};
      
      if (this.color) {
        style.backgroundColor = this.color;
      }
      
      if (this.borderColor && this.borderColor.startsWith('#')) {
        style.borderColor = this.borderColor;
      }
      
      return style;
    }
  }
};
</script> 